import { Venue, VenueDaySettings } from 'types/model'

export function resolveGuestlistEnabledExternally(
  daySettings?: Partial<VenueDaySettings> | null,
  venue?: Pick<Venue, 'config'> | null
): boolean {
  if (daySettings?.acceptingGuestlistExternally !== undefined) {
    return Boolean(daySettings.acceptingGuestlistExternally)
  }

  if (daySettings?.guestlistEnabledExternally !== undefined) {
    return Boolean(daySettings.guestlistEnabledExternally)
  }

  return Boolean(venue?.config?.defaultGuestlistEnabledExternally)
}
